import { useState, useEffect } from "react";
import { useUser } from "@/contexts";
import { db } from "@/services/config";
import {
  collection,
  query,
  where,
  limit,
  onSnapshot,
} from "firebase/firestore";

export const usePermissions = () => {
  const { user } = useUser();
  const [activePlan, setActivePlan] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user?.uid) {
      setLoading(false);
      return;
    }

    // Busca na sua coleção users_plans um plano que:
    // 1. Pertença ao usuário
    // 2. Esteja com status 'succeeded' (confirmado pelo Webhook)
    const q = query(
      collection(db, "users_plans"),
      where("userId", "==", user.uid),
      where("status", "==", "succeeded"),
      limit(1),
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      if (!snapshot.empty) {
        const data = snapshot.docs[0].data();
        const expiresAt = data.expiresAt?.toDate();
        const now = new Date();

        if (expiresAt && expiresAt > now) {
          setActivePlan(data);
        } else {
          setActivePlan(null);
        }
      } else {
        setActivePlan(null);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, [user?.uid]);

  const hasPermission = (permissionName: string) => {
    if (!activePlan) return false;

    return activePlan.permissions?.includes(permissionName) || false;
  };

  return { hasPermission, activePlan, loading };
};
